import { AlertTriangle, Ban } from 'lucide-react';
import { Badge } from '@ncoder/ui';

type UsageHealthStatus = 'over_budget' | 'blocked';

interface UsageStatusConfig {
  label: string;
  icon: typeof AlertTriangle;
  className: string;
}

// Text-safe `-strong` state colours — see StatusBadge for why the fill tokens are not used as text.
const USAGE_STATUS_CONFIG: Record<UsageHealthStatus, UsageStatusConfig> = {
  over_budget: {
    // The member's remaining allowance for the cycle is $0 (backend #327 split). They are not yet
    // refused by LiteLLM — that is `blocked` — but the next request will be.
    label: 'Limit reached',
    icon: AlertTriangle,
    className: 'border-warning/25 bg-warning/10 text-warning-strong',
  },
  blocked: {
    label: 'Blocked',
    icon: Ban,
    className: 'border-destructive/25 bg-destructive/10 text-destructive-strong',
  },
};

// Blocked (LiteLLM has cut the seat off) takes precedence over merely over-budget.
export function UsageStatusBadge({ blocked, overBudget }: { blocked: boolean; overBudget: boolean }) {
  if (!blocked && !overBudget) return null;
  const cfg = USAGE_STATUS_CONFIG[blocked ? 'blocked' : 'over_budget'];

  return (
    <Badge
      variant="outline"
      className={`shrink-0 gap-1 whitespace-nowrap px-2 py-0 text-[11px] font-medium ${cfg.className}`}
    >
      <cfg.icon className="h-3 w-3 shrink-0" aria-hidden />
      {cfg.label}
    </Badge>
  );
}
